import { Link, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { MobileCtaBar } from "@/components/MobileCtaBar";

// NOT: Bu metinler örnek taslaktır. İşletme unvanı ve iletişim
// bilgileri kesinleştiğinde güncellenmelidir.
const CONTENT = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    paragraphs: [
      "Bu metin örnek taslaktır; işletme bilgileri kesinleştiğinde güncellenecektir.",
      "Salihli Oto Çekici olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında veri sorumlusu sıfatıyla hareket etmekteyiz.",
      "Hizmet talebiniz sırasında paylaştığınız ad, telefon numarası ve konum bilgisi; yalnızca oto kurtarma hizmetinin sağlanması, fiyatlandırma ve iletişim amaçlarıyla işlenmektedir.",
      "Kişisel verileriniz açık rızanız olmaksızın üçüncü kişilerle paylaşılmaz ve hizmet süreci tamamlandıktan sonra makul süre içinde silinir.",
      "KVKK'nın 11. maddesi kapsamındaki haklarınızı (verilerinize erişme, düzeltilmesini veya silinmesini talep etme vb.) telefon numaramız aracılığıyla kullanabilirsiniz.",
    ],
  },
  "gizlilik-politikasi": {
    title: "Gizlilik Politikası",
    paragraphs: [
      "Bu metin örnek taslaktır; işletme bilgileri kesinleştiğinde güncellenecektir.",
      "Bu web sitesi, ziyaretçilerinden doğrudan form aracılığıyla kişisel veri toplamaz. İletişim, telefon araması ve WhatsApp uygulaması üzerinden gerçekleşir.",
      "WhatsApp üzerinden yapılan görüşmeler, WhatsApp'ın kendi gizlilik politikasına tabidir.",
      "Siteyi geliştirmek ve reklam performansını ölçmek amacıyla ileride Google Analytics / Google Tag Manager kullanılabilir. Bu durumda toplanan veriler anonimleştirilmiş istatistiksel verilerle sınırlıdır.",
    ],
  },
  "cerez-politikasi": {
    title: "Çerez Politikası",
    paragraphs: [
      "Bu metin örnek taslaktır; işletme bilgileri kesinleştiğinde güncellenecektir.",
      "Bu site, temel işlevsellik dışında zorunlu olmayan çerez kullanmamaktadır.",
      "Google Tag Manager / Analytics entegrasyonu etkinleştirildiğinde, performans ve ölçümleme amaçlı çerezler kullanılabilir. Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman silebilir veya engelleyebilirsiniz.",
    ],
  },
};

export default function LegalPage() {
  const { pathname } = useLocation();
  const page = CONTENT[pathname.replace(/^\//, "")];

  if (!page) return null;

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-page-${pathname.replace(/^\//, "")}`}>
      <Header />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-32 md:pt-40">
        <nav aria-label="breadcrumb" className="text-xs font-semibold text-neutral-400">
          <Link to="/" className="hover:text-brand" data-testid="breadcrumb-home">
            Ana Sayfa
          </Link>
          <span className="mx-2" aria-hidden="true">
            /
          </span>
          <span className="text-neutral-600">{page.title}</span>
        </nav>
        <h1 className="mt-4 font-display text-3xl font-extrabold uppercase tracking-tight text-ink-900 sm:text-4xl" data-testid="legal-title">
          {page.title}
        </h1>
        <div className="mt-8 space-y-5">
          {page.paragraphs.map((p, i) => (
            <p key={i} className={`leading-relaxed ${i === 0 ? "rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm font-semibold text-amber-800" : "text-neutral-600"}`}>
              {p}
            </p>
          ))}
        </div>
      </main>
      <Footer />
      <MobileCtaBar />
    </div>
  );
}
